export { FederatedPointerEvent as GEvent } from '@antv/g';
export { buildTableHierarchy } from './facet/layout/build-table-hierarchy';
export { Hierarchy } from './facet/layout/hierarchy';
export { Node, type NodeProperties } from './facet/layout/node';

export * from './cell';
export * from './common';
export * from './data-set';
export * from './facet';
export * from './interaction';
export * from './shared';
export * from './sheet-type';
export * from './styles';
export * from './theme';
export * from './ui/scrollbar';
export * from './ui/tooltip';
export * from './utils';

export const version = '@antv/s2-v2.4.11';
